import MesAidesLayout from "@/components/mes-aides-layout.vue"
import Home from "@/views/home.vue"

export default {
  Home,
  MesAidesLayout,
}
